import React, { useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function SettingsPage() {
  const [tab, setTab] = useState("otp");
  const [otpForm, setOtpForm] = useState({ defaultOtp:"111111", smsProvider:"none" });
  const [adminForm, setAdminForm] = useState({ mobile:"", name:"" });
  const [saving, setSaving] = useState(false);

  const saveOtpSettings = async () => {
    setSaving(true);
    try {
      await api.post("/admin/settings/otp", otpForm);
      toast.success("OTP settings saved");
    } catch { toast.error("Error saving settings"); }
    finally { setSaving(false); }
  };

  const createAdmin = async () => {
    if (!/^[6-9]\d{9}$/.test(adminForm.mobile)) return toast.error("Enter valid mobile");
    if (!adminForm.name.trim()) return toast.error("Name is required");
    setSaving(true);
    try {
      await api.post("/admin/create-admin", adminForm);
      toast.success("Admin user created!");
      setAdminForm({ mobile:"", name:"" });
    } catch { toast.error("Error creating admin"); }
    finally { setSaving(false); }
  };

  return (
    <AdminLayout title="Settings">
      <div className="tabs">
        <button className={"tab"+(tab==="otp"?" tab--active":"")} onClick={()=>setTab("otp")}>🔐 OTP / SMS</button>
        <button className={"tab"+(tab==="admins"?" tab--active":"")} onClick={()=>setTab("admins")}>👤 Manage Admins</button>
        <button className={"tab"+(tab==="system"?" tab--active":"")} onClick={()=>setTab("system")}>⚙️ System Info</button>
      </div>

      {tab === "otp" && (
        <div className="card" style={{ maxWidth:480 }}>
          <div className="card__header"><div className="card__title">🔐 OTP Configuration</div></div>
          <div className="card__body">
            <div className="alert alert--warning" style={{ marginBottom:16 }}>
              ⚠️ Currently in testing mode. All users login with DEFAULT_OTP. Remove it when you add Fast2SMS.
            </div>
            <div className="form-group">
              <label className="label">Default OTP (Testing)</label>
              <input className="input" type="text" maxLength={6} value={otpForm.defaultOtp}
                onChange={e => setOtpForm(p=>({...p,defaultOtp:e.target.value}))} />
              <div style={{ fontSize:12, color:"#6C757D", marginTop:4 }}>All users use this OTP during testing phase. Remove when Fast2SMS is ready.</div>
            </div>
            <div className="form-group">
              <label className="label">SMS Provider</label>
              <select className="input" value={otpForm.smsProvider} onChange={e=>setOtpForm(p=>({...p,smsProvider:e.target.value}))}>
                <option value="none">None (Testing Mode)</option>
                <option value="fast2sms">Fast2SMS (₹50 free credit)</option>
                <option value="msg91">MSG91</option>
                <option value="twilio">Twilio</option>
              </select>
            </div>
            {otpForm.smsProvider !== "none" && (
              <div className="form-group">
                <label className="label">API Key</label>
                <input className="input" type="password" placeholder="Enter SMS provider API key" />
              </div>
            )}
            <button className="btn btn--primary" onClick={saveOtpSettings} disabled={saving}>
              {saving ? <span className="spinner spinner--sm spinner--white" /> : "Save Settings"}
            </button>
          </div>
        </div>
      )}

      {tab === "admins" && (
        <div style={{ maxWidth:480 }}>
          <div className="card" style={{ marginBottom:16 }}>
            <div className="card__header"><div className="card__title">➕ Create Admin User</div></div>
            <div className="card__body">
              <div className="alert alert--info" style={{ marginBottom:14 }}>
                The user must already be registered on ZevaZeva. Enter their mobile number to grant admin access.
              </div>
              <div className="form-group">
                <label className="label">Admin Name</label>
                <input className="input" placeholder="Full name" value={adminForm.name} onChange={e=>setAdminForm(p=>({...p,name:e.target.value}))} />
              </div>
              <div className="form-group">
                <label className="label">Mobile Number</label>
                <input className="input" type="tel" maxLength={10} placeholder="Registered mobile number"
                  value={adminForm.mobile} onChange={e=>setAdminForm(p=>({...p,mobile:e.target.value.replace(/\D/g,"")}))} />
              </div>
              <button className="btn btn--primary" onClick={createAdmin} disabled={saving}>
                {saving ? <span className="spinner spinner--sm spinner--white" /> : "Create Admin"}
              </button>
            </div>
          </div>
          <div className="alert alert--primary">
            💡 <strong>Make yourself admin via MongoDB Atlas:</strong><br/>
            db.users.updateOne(&#123; mobile: "your_number" &#125;, &#123; $set: &#123; role: "admin" &#125; &#125;)
          </div>
        </div>
      )}

      {tab === "system" && (
        <div className="card" style={{ maxWidth:480 }}>
          <div className="card__header"><div className="card__title">⚙️ System Information</div></div>
          <div className="card__body">
            {[
              ["Frontend", "https://zevazeva.com"],
              ["Admin Panel", "https://admin.zevazeva.com"],
              ["Backend API", process.env.REACT_APP_API_URL || 'https://api.zevazeva.com/api'],
              ["Database", "MongoDB Atlas"],
              ["Node.js Hosting", "Hostinger"],
              ["Version", "1.0.0"],
            ].map(([k,v]) => (
              <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid #f1f3f5", fontSize:13 }}>
                <span style={{ color:"#6C757D" }}>{k}</span>
                <span style={{ fontWeight:500, color:"#212529" }}>{v}</span>
              </div>
            ))}
            <div style={{ marginTop:16 }}>
              <button className="btn btn--outline btn--sm" onClick={() => api.get("/health").then(() => toast.success("API is healthy ✅")).catch(() => toast.error("API not reachable"))}>
                🩺 Test API Connection
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
